<template>
	<div class="campus">
		<div class="header" style="background: white;">
			<div class="container">
				<div class="flex">
					<div class="logo"><img src="../image/zsdb_logo.png" class="logoImg" style="width:132px"></div>
					<div class="menu" id="nav">
						<ul>
							<li class="menulist"><a @click="gotoHome()" class="">首页</a></li>
							<li class="menulist"><a class="on" @click="gotoRecruit()">招聘公告</a></li>
							<li class="menulist"><a @click="gotoCampus()" class="">校园招聘</a></li>
							<li class="menulist"><a @click="gotoSociety()" class="">社会招聘</a></li>
							<!-- <li class="menulist"><a @click="gotoIntern()" class="">实习生招聘</a></li> -->
						</ul>
					</div>
					<div class="user">
						<div v-show="islogin" class="isLogin" style="display: none;">
							<div @click="gotopersonal()" style="cursor: pointer;"><span>个人中心</span></div>
							<span class="divider">|</span>
							<div @click="exit()" style="cursor: pointer;"><span> 退出</span></div>
						</div>
						<div v-show="unlogin" class="unLogin" style="display: none;">
							<div @click="gotologin()" style="cursor: pointer;"><span>登录</span></div>
							<span class="divider">|</span>
							<div @click="gotoregister()" style="cursor: pointer;"><span>注册</span></div>
						</div>
					</div>
					<el-popover class="ewm" trigger="hover" placement="bottom">
						<img src="../image/ewm.jpg" class="code">
						<img src="../image/icoewm.png" slot="reference" class="ico">
					</el-popover>

				</div>
			</div>
		</div>

		<div class="pagesbanner">
			<img src="../image/xydh01.png" class="dh wow  fadeInLeft" style="left: 0">
			<img src="../image/xydh02.png" class="dh wow  fadeInLeft" style="right: 0">
			<div class="text">
				<h3>招聘公告</h3>
				<p>Recruit Notice</p>
			</div>
		</div>
		<a name="zw" style="position: relative;top: -80px;"></a>
		<div class="nidrpagestext">
			<el-page-header class="go_back" @back="goBack" content="">
			</el-page-header>
			<div class="recruit_Info">
				<!-- <div class="recruit_article">
					<div class="ql-container ql-snow">
						<div class="ql-editor">
							<div v-html="article"></div>
						</div>
					</div>
				</div> -->
				<WangEditorUser ref="wangEditor" class="wangarticle" v-model="article"></WangEditorUser>
				<div class="annex_title">
					<span style="font-size: 16px;">附件：</span>
				</div>
				<div class="annex_list" v-for="(item,index) in annexList" :key="index" :annexList="item">
					<el-link type="primary" @click="downloadAnnex(item.fileLink)">{{item.fileName}}</el-link>
				</div>
			</div>
		</div>
		<div class="footer">
			<div class="container">
				<p>&copy 2022 Inc. All Rights Reserved. 中水东北勘测设计研究有限责任公司 版权所有 吉ICP备2022003947号-1
					技术支持：中水东北勘测设计研究有限责任公司数字与智慧工程院
					<br />吉公网安备 22010402001082号
				</p>
			</div>
		</div>
		<backtop></backtop>
	</div>
</template>

<script>
	import jobinfo from "../components/jobinfo.vue"
	import backtop from "../components/backtop.vue"
	import WangEditorUser from "@/components/weditorUser.vue"
	import {
		loginstatus,
		Logout,
		queryPosition,
		collectPosition,
		requestPosition,
		queryArticle,
	} from '../api/user.js'
	// @ is an alias to /src
	export default {
		components: {
			jobinfo,
			backtop,
			WangEditorUser,
		},

		data() {
			return {
				islogin: false,
				unlogin: false,
				userId: '',
				articleName: '',
				article: null,
				annexList: [],
			}
		},

		mounted() {
			this.articleName = this.$route.query.articleName
			loginstatus().then((res) => {
				if (res.code == 200) {
					this.islogin = true;
					this.unlogin = false;
					this.userId = res.data;
				} else if (res.code != 200) {
					this.islogin = false;
					this.unlogin = true;
				}
			});
			queryArticle({
				articleName: this.articleName,
			}).then((res) => {
				this.article = res.data.articleValue
				this.annexList = res.data.articleAttachmentFileVoList
			});
		},

		methods: {
			downloadAnnex(fileLink) {
				var baseUrl;
				baseUrl = fileLink
				window.open(baseUrl, '_blank')
			},
			goBack() {
				this.$router.push('/recruitInfoList')
			},
			exit() {
				Logout().then((res) => {
					location.reload()
				})
			},
			gotoRecruit() {
				this.$router.push('/recruitInfoList')
			},
			gotologin() {
				this.$router.push('/login')
			},
			gotoregister() {
				this.$router.push('/register')
			},
			gotoHome() {
				this.$router.push('/')
			},
			gotoAboutus() {
				this.$router.push('/aboutus/introduce')
			},
			gotoCampus() {
				this.$router.push('/campus')
			},
			gotoSociety() {
				this.$router.push('/society')
			},
			gotoIntern() {
				this.$router.push('/intern')
			},
			jobsearch() {
				queryPosition({
					positionName: this.input,
				}).then((res) => {
					var i = 0
					var j = 0
					var arr = new Array()
					for (i; i < res.data.length; i++) {
						if (res.data[i].type == 0) {
							arr[j] = res.data[i]
							j++
						}
					}
					if (arr.length != 0) {
						this.campusjobinfo = arr
						this.haveshowposition = true
						this.noneshowposition = false
					} else {
						this.haveshowposition = false
						this.noneshowposition = true
					}
				});
			},
			gotopersonal() {
				this.$router.push('/personal/resume')
			},
		}
	}
</script>

<style scoped>
	@import url(../assets/css/index.css);
	@import url(../assets/css/quillsnowcss.scss);

	.nidrpagestext {
		min-height: calc(100vh - 460px) !important;
		background-color: white;
		padding-bottom: 35px;
		padding-top: 35px;
	}

	.recruit_Info {
		width: 50%;
		margin-left: 25%;
	}

	.pagesbanner {
		background: url(../image/bannersxs.jpg) top center no-repeat;
	}

	.recruit_article {
		width: 100%;
		margin-top: 35px;
	}

	.article {}

	.annex_list {
		margin-top: 10px;
	}

	.annex_title {
		margin-top: 35px;
	}

	.go_back {
		margin-left: 25%;
	}
</style>
